module.exports = __webpack_public_path__ + "mu.8400b4ab.svg";